import { withProps, renameProps } from 'recompose';
import { compose } from 'redux';
import ImageQuestion from './ImageQuestion';
import ImageMultiChoiceGroupField from './ImageMultiChoiceGroupField';

export default compose(
  withProps({ inputField: ImageMultiChoiceGroupField }),
  renameProps({ onAnswer: 'handleSubmit', answer: 'initialValues' }),
)(ImageQuestion);
